<div id="angularRoot" style="height:0% !important">
  <div [hidden]="!isHTTPRequestInProgress" class="spinner">
    <div class="double-bounce1"></div>
    <div class="double-bounce2"></div>
  </div>
</div>


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/spinnerComponent/spinner.template.html